import {
    LoginHistoryDto,
    LoginHistoryEntry,
} from '@accountFederation/modules/settings/loginHistory/types';

export const mapLoginHistoryItems = (dtoItems: LoginHistoryDto[]): LoginHistoryEntry[] => {
    return dtoItems.map((dto) => ({
        date: new Date(dto.created_at),
        ip: dto.client_ip,
    }));
};
